import { FlexBox } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback, useMemo } from 'react';

import type { SettingsProductTeaserFeature } from 'app/views/layout/views/settings/components/settingsProductTeaser';
import { ProductTeaserFeaturesGrid } from 'app/views/layout/views/settings/components/settingsProductTeaser/components/productTeaserFeaturesGrid';

import { copilotProductFeatures } from './copilotProductFeatures';

type CopilotFeaturesRowProps = {
  showLearnMore?: boolean;
};

export const CopilotFeaturesRow = ({
  showLearnMore = true,
}: CopilotFeaturesRowProps): JSX.Element => {
  const handleLearnMoreClick = useCallback((url: string) => {
    ampli.agentCopilotTrialLearnMoreClicked({ url });
  }, []);

  const features = useMemo((): readonly SettingsProductTeaserFeature[] => {
    return copilotProductFeatures.map((feature) => ({
      title: feature.title,
      description: feature.description,
      icon: feature.icon,
      ...(showLearnMore && {
        learnMoreUrl: feature.learnMoreUrl,
        onLearnMoreClick: handleLearnMoreClick,
      }),
    }));
  }, [handleLearnMoreClick, showLearnMore]);

  return (
    <FlexBox padding="400 0">
      <ProductTeaserFeaturesGrid columns={4} features={features} />
    </FlexBox>
  );
};
